import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './AllCategoryHome.css';

const AllCategory = () => {
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState({});
  const [activeCategoryId, setActiveCategoryId] = useState(null);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/getCategoryHome`);
        if (response.data.status === 'ok') {
          setCategories(response.data.data);
        } else {
          setMessage(response.data.message);
        }
      } catch (error) {
        setMessage('An error occurred: ' + error.message);
      }
    };

    fetchCategories();
  }, []);

  const fetchSubcategories = async (categoryId) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/getSubCategory/${categoryId}`);
      if (response.data.status === 'ok') {
        setSubCategories((prev) => ({
          ...prev,
          [categoryId]: response.data.data,
        }));
        setActiveCategoryId(categoryId);
      } else {
        console.warn('No subcategories found:', response.data.message);
        setActiveCategoryId(null);
      }
    } catch (error) {
      console.error('AxiosError:', error);
      setActiveCategoryId(null);
    }
  };

  const handleView = (categoryId) => {
    if (categoryId) {
      window.location.href = `/CategoryView/${categoryId}`;
    }
  };

  const handleMouseLeaveAll = (e) => {
    const related = e.relatedTarget;
    if (!(related instanceof Node) || !e.currentTarget.contains(related)) {
      setActiveCategoryId(null);
    }
  };

  return (
    <div className="tradeindia-category-container">
      {message && <div className="error-message">{message}</div>}
      
      <div className="category-header">
        <h3 className="category-title">Top Categories</h3>
        <a href="/categories" className="view-all-link">View all </a>
      </div>

      <div className="category-sidebar-wrapper" onMouseLeave={handleMouseLeaveAll}>
        <div className="category-list">
          {categories.map((cat, index) => (
            <div
              key={index}
              className={`category-item ${activeCategoryId === cat._id ? 'active' : ''}`}
              onMouseEnter={() => fetchSubcategories(cat._id)}
            >
              <div className="category-content" onClick={() => handleView(cat._id)}>
                <div className="category-icon">
                  {cat.image ? (
                    <img
                      src={`${process.env.REACT_APP_API_URL}/${cat.image.replace('\\', '/')}`}
                      className="category-image"
                      alt={cat.name}
                    />
                  ) : (
                    <div className="default-icon">
                      <i className="fas fa-folder"></i>
                    </div>
                  )}
                </div>
                <div className="category-info">
                  <h5 className="category-name">{cat.name}</h5>
                </div>
                <div className="category-arrow">
                  <i className="fas fa-chevron-right"></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        {activeCategoryId && subCategories[activeCategoryId]?.length > 0 && (
          <div className="subcategory-dropdown">
            <div className="subcategory-header">
              <h4>Subcategories</h4>
            </div>
            <div className="subcategory-grid">
              {subCategories[activeCategoryId].map((subCat, subIndex) => (
                <div key={subIndex} className="subcategory-item">
                  <div className="subcategory-icon">
                    {subCat.image ? (
                      <img
                        src={`${process.env.REACT_APP_API_URL}/${subCat.image.replace('\\', '/')}`}
                        className="subcategory-image"
                        alt={subCat.name}
                      />
                    ) : (
                      <div className="default-subcategory-icon">
                        <i className="fas fa-cube"></i>
                      </div>
                    )}
                  </div>
                  <span className="subcategory-name">{subCat.name}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AllCategory;